// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"30dcce45","453":"75d6ae44","455":"3b96736a","977":"be083446"}[chunkId] + ".chunk.js";
};